import { useFeatureFlags } from './use-feature-flags';

export function useDisableLinkPrefetch() {
  const { DISABLE_LINK_PREFETCH } = useFeatureFlags();

  return { disableLinkPrefetch: DISABLE_LINK_PREFETCH };
}
